var _g, _g2, _g3, _g4, _g5, _g6, _rect, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThankyou(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e7cDziBp3Pj1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 298 85",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e7cDziBp3Pj2",
    transform: "translate(0-70)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 3,
    ry: 3,
    transform: "translate(11 40)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4688,47.6602v1.923l1.875,1.1043v-1.9141l-1.875-1.1132Zm2.1874,3.0273l1.875-1.1043v-1.923l-1.875,1.1132v1.9141Zm1.7188-3.2813L21.5,46.3125l-1.875,1.0937L21.5,48.5l1.875-1.0938Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4688,52.6602v1.923l1.875,1.1043v-1.9141l-1.875-1.1132Zm2.1874,3.0273l1.875-1.1043v-1.923l-1.875,1.1132v1.9141Zm1.7188-3.2813L24.5,51.3125l-1.875,1.0937L24.5,53.5l1.875-1.0938Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4688,52.6602v1.923l1.875,1.1043v-1.9141l-1.875-1.1132Zm2.1874,3.0273l1.875-1.1043v-1.923l-1.875,1.1132v1.9141Zm1.7188-3.2813L18.5,51.3125l-1.875,1.0937L18.5,53.5l1.875-1.0938Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "e7cDziBp3Pj7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 3,
    ry: 3,
    transform: "translate(53 40)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4688,52.6602v1.923l1.875,1.1043v-1.9141l-1.875-1.1132Zm2.1874,3.0273l1.875-1.1043v-1.923l-1.875,1.1132v1.9141Zm1.7188-3.2813L66.5,51.3125l-1.875,1.0937L66.5,53.5l1.875-1.0938Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4688,47.6602v1.923l1.875,1.1043v-1.9141l-1.875-1.1132Zm2.1874,3.0273l1.875-1.1043v-1.923l-1.875,1.1132v1.9141Zm1.7188-3.2813L63.5,46.3125l-1.875,1.0937L63.5,48.5l1.875-1.0938Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4688,52.6602v1.923l1.875,1.1043v-1.9141l-1.875-1.1132Zm2.1874,3.0273l1.875-1.1043v-1.923l-1.875,1.1132v1.9141Zm1.7188-3.2813L60.5,51.3125l-1.875,1.0937L60.5,53.5l1.875-1.0938Z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "e7cDziBp3Pj12"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 3,
    ry: 3,
    transform: "translate(95 40)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.469,47.6602v1.923l1.875,1.1043v-1.9141l-1.875-1.1132Zm2.187,3.0273l1.875-1.1043v-1.923l-1.875,1.1132v1.9141Zm1.719-3.2813L105.5,46.3125l-1.875,1.0937L105.5,48.5l1.875-1.0938Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.469,52.6602v1.923l1.875,1.1043v-1.9141l-1.875-1.1132Zm2.187,3.0273l1.875-1.1043v-1.923l-1.875,1.1132v1.9141Zm1.719-3.2813L102.5,51.3125l-1.875,1.0937L102.5,53.5l1.875-1.0938Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.469,52.6602v1.923l1.875,1.1043v-1.9141l-1.875-1.1132Zm2.187,3.0273l1.875-1.1043v-1.923l-1.875,1.1132v1.9141Zm1.719-3.2813L108.5,51.3125l-1.875,1.0937L108.5,53.5l1.875-1.0938Z",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "e7cDziBp3Pj17",
    transform: "translate(-60 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 1,
    ry: 1,
    transform: "translate(193 32)",
    fill: "#E5F6FE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 30,
    rx: 0,
    ry: 0,
    transform: "translate(206 32)",
    fill: "#137FD9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.5,
    transform: "translate(208.5 47.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e7cDziBp3Pj24)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M203,47.5c0-1.4587.579-2.8576,1.611-3.8891C205.642,42.5795,207.041,42,208.5,42s2.858.5795,3.889,1.6109C213.421,44.6424,214,46.0413,214,47.5s-.579,2.8576-1.611,3.8891C211.358,52.4205,209.959,53,208.5,53s-2.858-.5795-3.889-1.6109C203.579,50.3576,203,48.9587,203,47.5Zm5.186,2.354l3.167-3.9585-.572-.4576-2.7,3.374-1.913-1.5935-.469.5632l2.487,2.0731v-.0007Z",
    clipRule: "evenodd",
    fill: "#3bd288",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e7cDziBp3Pj24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    rx: 0,
    ry: 0,
    transform: "translate(203 42)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M197.589,36.126h-1.101v-.87h-.63v.87h-.573v.57h.573v1.263c0,.765.381,1.116,1.032,1.116.36,0,.651-.129.882-.285l-.249-.501c-.171.108-.384.195-.579.195-.252,0-.456-.15-.456-.537v-1.251h1.101v-.57Z",
    fill: "#137FD9"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "e7cDziBp3Pj27",
    transform: "translate(-60 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 1,
    ry: 1,
    transform: "translate(193 32)",
    fill: "#E5F6FE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 30,
    rx: 0,
    ry: 0,
    transform: "translate(206 32)",
    fill: "#137FD9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.5,
    transform: "translate(208.5 47.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e7cDziBp3Pj34)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M203,47.5c0-1.4587.579-2.8576,1.611-3.8891C205.642,42.5795,207.041,42,208.5,42s2.858.5795,3.889,1.6109C213.421,44.6424,214,46.0413,214,47.5s-.579,2.8576-1.611,3.8891C211.358,52.4205,209.959,53,208.5,53s-2.858-.5795-3.889-1.6109C203.579,50.3576,203,48.9587,203,47.5Zm5.186,2.354l3.167-3.9585-.572-.4576-2.7,3.374-1.913-1.5935-.469.5632l2.487,2.0731v-.0007Z",
    clipRule: "evenodd",
    fill: "#3bd288",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e7cDziBp3Pj34"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    rx: 0,
    ry: 0,
    transform: "translate(203 42)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M197.589,36.126h-1.101v-.87h-.63v.87h-.573v.57h.573v1.263c0,.765.381,1.116,1.032,1.116.36,0,.651-.129.882-.285l-.249-.501c-.171.108-.384.195-.579.195-.252,0-.456-.15-.456-.537v-1.251h1.101v-.57Z",
    fill: "#137FD9"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "e7cDziBp3Pj37",
    transform: "translate(-59 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 1,
    ry: 1,
    transform: "translate(193 32)",
    fill: "#E5F6FE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 30,
    rx: 0,
    ry: 0,
    transform: "translate(206 32)",
    fill: "#137FD9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.5,
    transform: "translate(208.5 47.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e7cDziBp3Pj44)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M203,47.5c0-1.4587.579-2.8576,1.611-3.8891C205.642,42.5795,207.041,42,208.5,42s2.858.5795,3.889,1.6109C213.421,44.6424,214,46.0413,214,47.5s-.579,2.8576-1.611,3.8891C211.358,52.4205,209.959,53,208.5,53s-2.858-.5795-3.889-1.6109C203.579,50.3576,203,48.9587,203,47.5Zm5.186,2.354l3.167-3.9585-.572-.4576-2.7,3.374-1.913-1.5935-.469.5632l2.487,2.0731v-.0007Z",
    clipRule: "evenodd",
    fill: "#3bd288",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e7cDziBp3Pj44"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    rx: 0,
    ry: 0,
    transform: "translate(203 42)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M197.589,36.126h-1.101v-.87h-.63v.87h-.573v.57h.573v1.263c0,.765.381,1.116,1.032,1.116.36,0,.651-.129.882-.285l-.249-.501c-.171.108-.384.195-.579.195-.252,0-.456-.15-.456-.537v-1.251h1.101v-.57Z",
    fill: "#137FD9"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 296,
    height: 20,
    rx: 10,
    ry: 10,
    transform: "translate(1 64)",
    opacity: 0.4,
    fill: "none",
    stroke: "#000",
    strokeOpacity: 0.21,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3,3"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e7cDziBp3Pj50)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "e7cDziBp3Pj50"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    rx: 0,
    ry: 0,
    transform: "translate(61 46)",
    fill: "#fff"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e7cDziBp3Pj54)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "e7cDziBp3Pj54"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    rx: 0,
    ry: 0,
    transform: "translate(58 51)",
    fill: "#fff"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e7cDziBp3Pj58)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "e7cDziBp3Pj58"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    rx: 0,
    ry: 0,
    transform: "translate(64 51)",
    fill: "#fff"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e7cDziBp3Pj62)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "e7cDziBp3Pj62"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    rx: 0,
    ry: 0,
    transform: "translate(103 46)",
    fill: "#fff"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e7cDziBp3Pj66)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "e7cDziBp3Pj66"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    rx: 0,
    ry: 0,
    transform: "translate(100 51)",
    fill: "#fff"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e7cDziBp3Pj70)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "e7cDziBp3Pj70"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    rx: 0,
    ry: 0,
    transform: "translate(106 51)",
    fill: "#fff"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "e7cDziBp3Pj72"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 1,
    ry: 1,
    transform: "translate(243 32)",
    fill: "#E5F6FE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 30,
    rx: 0,
    ry: 0,
    transform: "translate(256 32)",
    fill: "#137FD9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.5,
    transform: "translate(258.5 47.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e7cDziBp3Pj79)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M253,47.5c0-1.4587.579-2.8576,1.611-3.8891C255.642,42.5795,257.041,42,258.5,42s2.858.5795,3.889,1.6109C263.421,44.6424,264,46.0413,264,47.5s-.579,2.8576-1.611,3.8891C261.358,52.4205,259.959,53,258.5,53s-2.858-.5795-3.889-1.6109C253.579,50.3576,253,48.9587,253,47.5Zm5.186,2.354l3.167-3.9585-.572-.4576-2.7,3.374-1.913-1.5935-.469.5632l2.487,2.0731v-.0007Z",
    clipRule: "evenodd",
    fill: "#3bd288",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e7cDziBp3Pj79"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    rx: 0,
    ry: 0,
    transform: "translate(253 42)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M247.589,36.126h-1.101v-.87h-.63v.87h-.573v.57h.573v1.263c0,.765.381,1.116,1.032,1.116.36,0,.651-.129.882-.285l-.249-.501c-.171.108-.384.195-.579.195-.252,0-.456-.15-.456-.537v-1.251h1.101v-.57Z",
    fill: "#137FD9"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e7cDziBp3Pj84)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "e7cDziBp3Pj84"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    rx: 0,
    ry: 0,
    transform: "translate(19 46)",
    fill: "#fff"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e7cDziBp3Pj88)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "e7cDziBp3Pj88"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    rx: 0,
    ry: 0,
    transform: "translate(16 51)",
    fill: "#fff"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e7cDziBp3Pj92)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "e7cDziBp3Pj92"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    rx: 0,
    ry: 0,
    transform: "translate(22 51)",
    fill: "#fff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127,11c0-2.76142,2.239-5,5-5h33c2.761,0,5,2.23858,5,5v51h-43v-51Z",
    fill: "#137FD9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "e7cDziBp3Pj95",
    d: "M153.43,35.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49,1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65c-.03-.24-.24-.42-.49-.42h-4c-.25,0-.46.18-.49.42l-.38,2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49,0-.61.22l-2,3.46c-.13.22-.07.49.12.64l2.11,1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11,1.65c-.19.15-.24.42-.12.64l2,3.46c.12.22.39.3.61.22l2.49-1c.52.4,1.08.73,1.69.98l.38,2.65c.03.24.24.42.49.42h4c.25,0,.46-.18.49-.42l.38-2.65c.61-.25,1.17-.59,1.69-.98l2.49,1c.23.09.49,0,.61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65ZM146,38.5c-1.93,0-3.5-1.57-3.5-3.5s1.57-3.5,3.5-3.5s3.5,1.57,3.5,3.5-1.57,3.5-3.5,3.5Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "e7cDziBp3Pj96",
    d: "M160.334,48.5717c.024-.1866.041-.3733.041-.5716c0-.1984-.017-.385-.041-.5717l1.231-.9625c.111-.0875.14-.245.07-.3733l-1.167-2.0184c-.07-.1283-.227-.175-.355-.1283l-1.453.5833c-.303-.2333-.63-.4258-.986-.5716l-.221-1.5459c-.018-.14-.14-.245-.286-.245h-2.334c-.145,0-.268.105-.285.245l-.222,1.5459c-.356.1458-.683.3441-.986.5716l-1.452-.5833c-.135-.0525-.286,0-.356.1283l-1.167,2.0184c-.076.1283-.041.2858.07.3733l1.231.9625c-.023.1867-.041.3792-.041.5717s.018.385.041.5716l-1.231.9625c-.111.0875-.14.245-.07.3734l1.167,2.0183c.07.1283.227.175.356.1283l1.452-.5833c.303.2333.63.4258.986.5717l.222,1.5458c.017.14.14.245.285.245h2.334c.146,0,.268-.105.286-.245l.221-1.5458c.356-.1459.683-.3442.986-.5717l1.453.5833c.134.0525.285,0,.355-.1283l1.167-2.0183c.07-.1284.041-.2859-.07-.3734l-1.231-.9625ZM156,50.0417c-1.126,0-2.042-.9158-2.042-2.0416c0-1.1259.916-2.0417,2.042-2.0417s2.042.9158,2.042,2.0417c0,1.1258-.916,2.0416-2.042,2.0416Z",
    transform: "matrix(0-1 1 0 107.99863 203.99873)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M158.842,10.8421v1.2632h5.895v-1.2632h-5.895ZM158.421,10h6.737c.112,0,.219.0444.298.1233s.123.1861.123.2978v2.1052c0,.1117-.044.2188-.123.2977-.079.079-.186.1234-.298.1234h-6.737c-.112,0-.219-.0444-.298-.1234-.079-.0789-.123-.186-.123-.2977v-2.1052c0-.1117.044-.2188.123-.2978s.186-.1233.298-.1233Zm.842,3.7895h2.526c.112,0,.219.0443.298.1233s.124.1861.124.2977v1.2632h.421v2.5263h-1.685v-2.5263h.421v-.8421h-2.526c-.112,0-.219-.0444-.298-.1233-.079-.079-.123-.1861-.123-.2978v-.8421h.842v.4211Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "e7cDziBp3Pj98",
    d: "M164.827,13.6091l-.744.7449c-.148.1472-.248.3343-.288.5385-.041.2042-.02.4158.06.6082.079.1923.214.3567.387.4723s.377.1774.585.1774.412-.0617.585-.1774.308-.28.388-.4723c.079-.1924.1-.404.059-.6082-.04-.2042-.14-.3917-.288-.5389l-.744-.7445Z",
    fill: "#540101"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M125,0.5h2v2h-.5c-.552,0-1,.44772-1,1v7.5c0,.5523.448,1,1,1h.5v2h-2c-.552,0-1-.4477-1-1v-11.5c0-.552285.448-1,1-1Z",
    fill: "#098AC5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M123.5,5h2.5v4h-2.5v-4Z",
    fill: "#E5F6FE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M130,54c0-1.1046.895-2,2-2h5c1.105,0,2,.8954,2,2v5c0,1.1046-.895,2-2,2h-7v-7Z",
    fill: "#098AC5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M133.333,58.25l-1.75-1.75l1.75-1.75.416.4156-1.342,1.3417l1.335,1.3344-.409.4083Zm2.334,0l-.416-.4156l1.342-1.3417-1.335-1.3344.409-.4083l1.75,1.75-1.75,1.75Z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M127,34v0c1.105,0,2,.8954,2,2v26h-2v-28Z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M170,23v0c-1.105,0-2,.8954-2,2v37h2v-39Z",
    fill: "#fff"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e7cDziBp3Pj108)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "e7cDziBp3Pj107",
    d: "M138.256,11.765c-.126-.6384-.469-1.2132-.972-1.6263s-1.133-.63885-1.784-.6387c-1.084,0-2.025.615-2.494,1.515-.551.0596-1.061.3207-1.431.7332s-.575.9474-.575,1.5018c0,1.2412,1.009,2.25,2.25,2.25h4.875c1.035,0,1.875-.84,1.875-1.875c0-.99-.769-1.7925-1.744-1.86Zm-.881,1.11l-1.744,1.7437c-.075.075-.191.075-.266,0l-1.74-1.7437h1.125v-1.5h1.5v1.5h1.125Z",
    fill: "#0F6FBE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e7cDziBp3Pj108"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    rx: 0,
    ry: 0,
    transform: "translate(131 8)",
    fill: "#fff"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "e7cDziBp3Pj110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 1,
    ry: 1,
    transform: "translate(193 32)",
    fill: "#E5F6FE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 30,
    rx: 0,
    ry: 0,
    transform: "translate(206 32)",
    fill: "#137FD9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.5,
    transform: "translate(208.5 47.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e7cDziBp3Pj117)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M203,47.5c0-1.4587.579-2.8576,1.611-3.8891C205.642,42.5795,207.041,42,208.5,42s2.858.5795,3.889,1.6109C213.421,44.6424,214,46.0413,214,47.5s-.579,2.8576-1.611,3.8891C211.358,52.4205,209.959,53,208.5,53s-2.858-.5795-3.889-1.6109C203.579,50.3576,203,48.9587,203,47.5Zm5.186,2.354l3.167-3.9585-.572-.4576-2.7,3.374-1.913-1.5935-.469.5632l2.487,2.0731v-.0007Z",
    clipRule: "evenodd",
    fill: "#3bd288",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e7cDziBp3Pj117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    rx: 0,
    ry: 0,
    transform: "translate(203 42)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M197.589,36.126h-1.101v-.87h-.63v.87h-.573v.57h.573v1.263c0,.765.381,1.116,1.032,1.116.36,0,.651-.129.882-.285l-.249-.501c-.171.108-.384.195-.579.195-.252,0-.456-.15-.456-.537v-1.251h1.101v-.57Z",
    fill: "#137FD9"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "e7cDziBp3Pj120",
    transform: "matrix(.984808 0.173648-.173648 0.984808 13.01708-.785904)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 7.5,
    transform: "translate(11 74)",
    fill: "#0F6FBE",
    stroke: "#098AC5"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2,
    transform: "translate(11 74)",
    fill: "#200101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,74h7",
    fill: "none",
    stroke: "#200101"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "e7cDziBp3Pj124",
    transform: "matrix(.984808 0.173648-.173648 0.984808 73.01708-.785904)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 7.5,
    transform: "translate(11 74)",
    fill: "#0F6FBE",
    stroke: "#098AC5"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2,
    transform: "translate(11 74)",
    fill: "#200101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,74h7",
    fill: "none",
    stroke: "#200101"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "e7cDziBp3Pj128",
    transform: "matrix(.984808 0.173648-.173648 0.984808 148.01708-.785904)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 7.5,
    transform: "translate(11 74)",
    fill: "#0F6FBE",
    stroke: "#098AC5"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2,
    transform: "translate(11 74)",
    fill: "#200101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,74h7",
    fill: "none",
    stroke: "#200101"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "e7cDziBp3Pj132",
    transform: "matrix(.984808 0.173648-.173648 0.984808 220.01708-.785904)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 7.5,
    transform: "translate(11 74)",
    fill: "#0F6FBE",
    stroke: "#098AC5"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2,
    transform: "translate(11 74)",
    fill: "#200101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,74h7",
    fill: "none",
    stroke: "#200101"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "e7cDziBp3Pj136",
    transform: "matrix(.984808 0.173648-.173648 0.984808 288.01708-.785904)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 7.5,
    transform: "translate(11 74)",
    fill: "#0F6FBE",
    stroke: "#098AC5"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2,
    transform: "translate(11 74)",
    fill: "#200101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,74h7",
    fill: "none",
    stroke: "#200101"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "e7cDziBp3Pj140",
    transform: "translate(0-70)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 3,
    ry: 3,
    transform: "translate(11 40)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4688,47.6602v1.923l1.875,1.1043v-1.9141l-1.875-1.1132Zm2.1874,3.0273l1.875-1.1043v-1.923l-1.875,1.1132v1.9141Zm1.7188-3.2813L21.5,46.3125l-1.875,1.0937L21.5,48.5l1.875-1.0938Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4688,52.6602v1.923l1.875,1.1043v-1.9141l-1.875-1.1132Zm2.1874,3.0273l1.875-1.1043v-1.923l-1.875,1.1132v1.9141Zm1.7188-3.2813L24.5,51.3125l-1.875,1.0937L24.5,53.5l1.875-1.0938Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4688,52.6602v1.923l1.875,1.1043v-1.9141l-1.875-1.1132Zm2.1874,3.0273l1.875-1.1043v-1.923l-1.875,1.1132v1.9141Zm1.7188-3.2813L18.5,51.3125l-1.875,1.0937L18.5,53.5l1.875-1.0938Z",
    fill: "#fff"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "e7cDziBp3Pj145",
    transform: "translate(0-70)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 3,
    ry: 3,
    transform: "translate(11 40)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4688,47.6602v1.923l1.875,1.1043v-1.9141l-1.875-1.1132Zm2.1874,3.0273l1.875-1.1043v-1.923l-1.875,1.1132v1.9141Zm1.7188-3.2813L21.5,46.3125l-1.875,1.0937L21.5,48.5l1.875-1.0938Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4688,52.6602v1.923l1.875,1.1043v-1.9141l-1.875-1.1132Zm2.1874,3.0273l1.875-1.1043v-1.923l-1.875,1.1132v1.9141Zm1.7188-3.2813L24.5,51.3125l-1.875,1.0937L24.5,53.5l1.875-1.0938Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4688,52.6602v1.923l1.875,1.1043v-1.9141l-1.875-1.1132Zm2.1874,3.0273l1.875-1.1043v-1.923l-1.875,1.1132v1.9141Zm1.7188-3.2813L18.5,51.3125l-1.875,1.0937L18.5,53.5l1.875-1.0938Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThankyou);
export default __webpack_public_path__ + "static/media/thankyou.165794b6eb7946920c522fb5421b7b93.svg";
export { ForwardRef as ReactComponent };